import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  max-width: 1200px;
  min-width: 700px;
  margin: 0 auto;
  padding: 20px;
  align-items: ${(props) => (props.foodies ? '' : 'center')};

  @media (max-width: 768px) {
    padding: 16px;
    gap: 20px;
    min-width: auto;
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

export const Content = styled.div`
  display: grid;
  grid-template-columns: ${(props) => (props.foodies ? '1fr 280px' : '1fr')};
  gap: ${(props) => (props.foodies ? '24px' : '0')};
  align-items: start;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 20px;
  }
`;

export const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const RightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  position: sticky;
  top: 20px;

  @media (max-width: 768px) {
    position: static;
    order: -1;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
`;

export const SectionTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  padding-left: 4px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 400px;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-family: 'Courier New', Courier, monospace;
  font-size: 13px;
  line-height: 1.6;
  resize: vertical;
  background: #f8f9fa;
  color: #333;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #2ec9b7;
    background: #fff;
  }

  &::placeholder {
    color: #999;
    font-style: italic;
  }

  @media (max-width: 768px) {
    min-height: 300px;
    font-size: 12px;
  }
`;

export const PreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 500px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
  width: 100%;
  max-width: 290px;

  @media (max-width: 768px) {
    max-width: none;
    height: 400px;
  }
`;

export const PreviewFrame = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  background: #fff;
  display: block;
  margin: 0 auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;
